module.exports = __webpack_public_path__ + "static/media/microwave.405e1cf3.svg";